import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Button } from 'react-bootstrap';
import { I18n } from 'react-redux-i18n';

const GoToSubstances = ({ onClick }) => (
  <Button bsSize="small" onClick={onClick}>
    {I18n.t('substance.goToSubstances')}
  </Button>
);

GoToSubstances.propTypes = {
  onClick: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch, { productId }) => ({
  onClick: () => dispatch(push({ pathname: '/substances', query: { productId } })),
});

export default connect(
  null,
  mapDispatchToProps,
)(GoToSubstances);
